
export const TerminalHistoryColumns = [
 

  { accessor: "hub", header: "نام هاب" },
  { accessor: "employee", header: "نام پرسنل" },
  { accessor: "assignmentDate", header: "تاریخ تخصیص" },
  { accessor: "cancellationDate", header: "تاریخ لغو تخصیص" },

];
